import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import {
    mapDispatchToProps,
    mapStateToProps,
    ProductListContainer as SourceProductListContainer,
} from 'SourceComponent/ProductList/ProductList.container';

export * from 'SourceComponent/ProductList/ProductList.container';

/** @namespace AdvoxBasic/Component/ProductList/Container/ProductListContainer */
export class ProductListContainer extends SourceProductListContainer {
    containerProps() {
        const {
            device,
            isLoading,
            isPaginationEnabled,
            isWidget,
            mix,
            pages,
            selectedFilters,
            title,
            totalPages,
            isSlider,
            isPromoList,
            isDailyPromoWithinSlider,
            renderOnlyPagination,
        } = this.props;

        return {
            device,
            isLoading,
            isPaginationEnabled,
            isWidget,
            mix,
            pages,
            selectedFilters,
            title,
            totalPages,
            currentPage: this._getPageFromUrl(),
            isShowLoading: this._isShowLoading(),
            isVisible: this._isVisible(),
            requestPage: this.requestPage,
            // disable this property to enable infinite scroll on desktop
            isInfiniteLoaderEnabled: this._getIsInfiniteLoaderEnabled(),
            isSlider,
            isPromoList,
            isDailyPromoWithinSlider,
            renderOnlyPagination,
        };
    }

    _getIsInfiniteLoaderEnabled() {
        const { isInfiniteLoaderEnabled, device } = this.props;

        if (device.isMobile && isInfiniteLoaderEnabled) {
            return isInfiniteLoaderEnabled;
        }

        return false;
    }

    requestPage = (currentPage = 1, isNext = false) => {
        const {
            sort,
            search,
            filter,
            pageSize,
            requestProductList,
            requestProductListInfo,
            noAttributes,
            noVariants,
            isWidget,
            isBrandPage,
        } = this.props;

        /**
         * In case the wrong category was passed down to the product list,
         * prevent it from being requested.
         */
        if (filter.categoryIds === -1) {
            return;
        }

        /**
         * Do not request page if there are no filters
         */
        if (!search && !this.isEmptyFilter()) {
            return;
        }

        // TODO: product list requests filters alongside the page
        // TODO: sometimes product list is requested more then once
        // TODO: the product list should not request itself, when coming from PDP

        const options = {
            isNext,
            noAttributes,
            noVariants,
            isBrandPage,
            args: {
                sort,
                filter,
                search,
                pageSize,
                currentPage,
            },
        };

        const infoOptions = {
            isBrandPage,
            args: {
                filter,
                search,
            },
        };

        requestProductList(options);

        if (!isWidget) {
            requestProductListInfo(infoOptions);
        }
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProductListContainer));
